import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../tokens/api-tokens';
import {
  FirmDetailPendingResponse,
  FirmDetailsResponse,
  SubmitFirmDetailsDto,
  SubmitFirmDetailsResponse
} from '../models/firm-details.model';

@Injectable({ providedIn: 'root' })
export class FirmDetailsService {
  private http = inject(HttpClient);
  private apiUrl = inject(API_BASE_URL);

  get(firmId: number): Observable<FirmDetailsResponse> {
    return this.http.get<FirmDetailsResponse>(`${this.apiUrl}/law-firm/${firmId}`);
  }

  getPending(firmId: number): Observable<FirmDetailPendingResponse> {
    return this.http.get<FirmDetailPendingResponse>(`${this.apiUrl}/law-firm/${firmId}/pending`);
  }

  submit(firmId: number, body: SubmitFirmDetailsDto): Observable<SubmitFirmDetailsResponse> {
    return this.http.put<SubmitFirmDetailsResponse>(`${this.apiUrl}/law-firm/${firmId}`, body);
  }
}
